// services/captcha/adapters/index.ts
//
// Provider id (the gateway's `data.captcha.provider`) -> adapter factory.
// A new provider is one adapter file plus one line here; the flow in
// withCaptcha and the host don't change. Candidates when the backend enables
// them: recaptcha, recaptcha-enterprise, turnstile, hcaptcha.

import { CaptchaAdapter } from '../types';
import { createArcaptchaAdapter } from './arcaptcha';

export const captchaAdapters: Record<string, () => CaptchaAdapter> = {
  arcaptcha: createArcaptchaAdapter
};

export const getCaptchaAdapter = (
  provider: string
): (() => CaptchaAdapter) | undefined =>
  Object.prototype.hasOwnProperty.call(captchaAdapters, provider)
    ? captchaAdapters[provider]
    : undefined;
